import { Table as AntTable, Empty, Spin } from "antd";
import "./table.css";
import { useRef } from "react";
import { useDragToScroll } from "@hooks/useDragToScroll";

export default function Table(props) {
  const {
    columns,
    dataSource,
    emptyText,
    components,
    loading = false,
    rowClassName,
    bodyCellClassName,
    scrollConfig,
    pagination = false,
    onChange
  } = props;
  const tableRef = useRef(null);
  useDragToScroll(tableRef);

  return (
    <div
      ref={tableRef}
      className="shadow-md remove-borders-radius-from-everything"
    >
      <AntTable
        loading={{
          spinning: loading,
          indicator: <Spin className="custom-spin" />,
        }}
        locale={{
          emptyText: () => (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={emptyText}
            />
          ),
        }}
        rowClassName={
          rowClassName
            ? rowClassName
            : (record, index) => (index % 2 === 0 ? "bg-[#F5F7F9]" : "")
        }
        components={
          components
            ? components
            : {
                body: {
                  cell: (props) => {
                    return (
                      <td
                        {...props}
                        className={
                          bodyCellClassName || "!py-2.5 !px-3.5 !border-border"
                        }
                      />
                    );
                  },
                },
                header: {
                  cell: (props) => {
                    return (
                      <th
                        {...props}
                        className="!bg-secondary-bg !py-1 !px-3.5 !bg-primary-tint !border-border"
                      >
                        {props.children}
                      </th>
                    );
                  },
                },
              }
        }
        scroll={scrollConfig ? scrollConfig : { x: 0, y: "70vh" }}
        sticky
        dataSource={dataSource}
        columns={columns}
        bordered={true}
        pagination={pagination}
        onChange={onChange}
      />
    </div>
  );
}
